<template>
  <div class="step-qna property-questions-section">
    <section>
      <b-container class="contain">
        <b-row align-v="center">
          <b-col style="text-align:right">
            <h5>Number of Bedrooms:</h5>
          </b-col>
          <b-col style="text-align:left">
            <b-form-input id="bed-count" v-model="bedRoomCount" class="number-input" type="number" 
              @blur="onBlurValue('bedRoomCount', 'bedroomsNum')"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <b-container class="contain">
        <b-row align-v="center">
          <b-col style="text-align:right">
            <h5>Number of Full Bathrooms:</h5>
          </b-col>
          <b-col style="text-align:left">
            <b-form-input id="full-bath-count" v-model="fullBathCount" class="number-input" type="number" 
              @blur="onBlurValue('fullBathCount', 'fullBathNum')"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <b-container class="contain">
        <b-row align-v="center">
          <b-col style="text-align:right">
            <h5>Number of Half Bathrooms:</h5>
          </b-col>
          <b-col style="text-align:left">
            <b-form-input id="half-bath-count" v-model="halfBathCount" class="number-input" type="number" 
              @blur="onBlurValue('halfBathCount', 'halfBathNum')"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <b-container class="contain">
        <b-row align-v="center">
          <b-col style="text-align:right">
            <h5>Number of Floors:</h5>
          </b-col>
          <b-col style="text-align:left">
            <b-form-input id="floor-count" v-model="floorCount" class="number-input" type="number" 
              @blur="onBlurValue('floorCount', 'floorsNum')"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <b-container class="contain">
        <b-row align-v="center">
          <b-col style="text-align:right">
            <h5>Year Built:</h5>
          </b-col>
          <b-col style="text-align:left">
            <b-form-input id="year-built" v-model="yearBuilt" class="number-input" type="number" 
              @blur="onBlurValue('yearBuilt', 'yearBuilt')"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <b-container class="contain">
        <b-row align-v="center">
          <b-col style="text-align:right">
            <h5>Square Footage:</h5>
          </b-col>
          <b-col style="text-align:left">
            <b-form-input id="sqft" v-model="sqft" class="number-input" type="number" 
              @blur="onBlurValue('sqft', 'sqFootage')"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <b-container class="contain">
        <b-row align-v="center">
          <b-col class="text-right">
            <h5>Garage Spaces:</h5>
          </b-col>
          <b-col class="text-left">
            <b-form-input id="garageSpaces" v-model="garageSpaces" class="number-input" type="number" 
              @blur="onBlurValue('garageSpaces', 'garageSpaces')"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <b-container class="contain">
        <b-row align-v="center">
          <b-col class="text-right">
            <h5>Carport Spaces:</h5>
          </b-col>
          <b-col class="text-left">
            <b-form-input id="carportSpaces" v-model="carportSpaces" class="number-input" type="number" 
              @blur="onBlurValue('carportSpaces', 'carportSpaces')"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <div class="d-flex justify-content-center">
        <h4>Has a basement?</h4>
      </div>
      <b-container class="h-buttons">
        <b-row>
          <b-col>
            <b-button class="button" pill variant="outline-secondary"
              :pressed="hasBasement === 'Yes - Finished'" 
              @click="onSelectedValue('hasBasement', 'basement', 'Yes - Finished')"
            >
              Yes - Finished
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button" pill variant="outline-secondary"
              :pressed="hasBasement === 'Yes - Unfinished'" 
              @click="onSelectedValue('hasBasement', 'basement', 'Yes - Unfinished')"
            >
              Yes - Unfinished
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button" pill variant="outline-secondary"
              :pressed="hasBasement === 'Yes - Partially Finished'" 
              @click="onSelectedValue('hasBasement', 'basement', 'Yes - Partially Finished')"
            >
              Yes - Partly Finished
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button" pill variant="outline-secondary"
              :pressed="hasBasement === 'No'" 
              @click="onSelectedValue('hasBasement', 'basement', 'No')"
            >
              No
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <div class="d-flex justify-content-center">
        <h4>Lot Size?</h4>
      </div>
      <b-container class="h-buttons">
        <b-row>
          <b-col>
            <b-button class="button" pill variant="outline-secondary" 
              :pressed="lotSize === 'Less than 1/2 acre'"
              @click="onSelectedValue('lotSize', 'lotSize', 'Less than 1/2 acre')"
            >
              Less than 1/2 acre
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button" pill variant="outline-secondary" 
              :pressed="lotSize === '1/2 - 1 acre'"
              @click="onSelectedValue('lotSize', 'lotSize', '1/2 - 1 acre')"
            >
              1/2 - 1 acre
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button" pill variant="outline-secondary"
              :pressed="lotSize === '1 acre plus'"
              @click="onSelectedValue('lotSize', 'lotSize', '1 acre plus')"
            >
              1 acre plus
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <b-container>
        <b-row class="d-flex justify-content-center">
          <h4>Is there a fireplace?</h4>
        </b-row>
        <b-row class="d-flex justify-content-center h-buttons">          
          <b-button 
            class="button yes-no" 
            pill 
            variant="outline-secondary" 
            :pressed="hasFireplace === true"
            @click="onSelectedValue('hasFireplace', 'fireplace', true)">Yes
          </b-button>
          <b-button 
            class="button yes-no"
            pill 
            variant="outline-secondary" 
            :pressed="hasFireplace === false"
            @click="onSelectedValue('hasFireplace', 'fireplace', false)"
          >
            No
          </b-button>
        </b-row>
      </b-container>
    </section>    
    <div v-if="hasFireplace && hasFireplace === true">
      <section>
        <div class="d-flex justify-content-center">
          <h4>Is the fireplace wood burning, gas starter or mock?</h4>
        </div>
        <b-container class="h-buttons">
          <b-row>
            <b-col>
              <b-button class="button" pill variant="outline-secondary" 
                :pressed="fireplaceType === 'Wood Burning'"
                @click="onSelectedValue('fireplaceType', 'fireplaceType', 'Wood Burning')"
              >
                Wood Burning
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button class="button" pill variant="outline-secondary" 
                :pressed="fireplaceType === 'Gas Starter'"
                @click="onSelectedValue('fireplaceType', 'fireplaceType', 'Gas Starter')"
              >
                Gas Starter
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button class="button" pill variant="outline-secondary" 
                :pressed="fireplaceType === 'Mock'"
                @click="onSelectedValue('fireplaceType', 'fireplaceType', 'Mock')"
              >
                Mock
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </div>
    <section>
      <div class="d-flex justify-content-center">
        <h4>Pool?</h4>
      </div>
      <b-container class="h-buttons">
        <b-row>
          <b-col>
            <b-button class="button" pill variant="outline-secondary"
              :pressed="pool === 'Inground'" 
              @click="onSelectedValue('pool', 'pool', 'Inground')"
            >
              In Ground
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button" pill variant="outline-secondary"
              :pressed="pool === 'Above ground'" 
              @click="onSelectedValue('pool', 'pool', 'Above ground')"
            >
              Above Ground
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button" pill variant="outline-secondary"
              :pressed="pool === 'None'" 
              @click="onSelectedValue('pool', 'pool', 'None')"
            >
              None
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>    
    <div v-if="pool && pool !== 'None'">
      <section>
        <div class="d-flex justify-content-center">
          <h4>Pool type</h4>
        </div>
        <b-container class="h-buttons">
          <b-row>
            <b-col>
              <b-button class="button" pill variant="outline-secondary"
                :pressed="poolType === 'Concrete'" 
                @click="onSelectedValue('poolType', 'poolType', 'Concrete')"
              >
              Concrete
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button class="button" pill variant="outline-secondary"
                :pressed="poolType === 'Liner'" 
                @click="onSelectedValue('poolType', 'poolType', 'Liner')"
              >
              Liner
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </div>
  </div>
</template>
<script>
import {saveField} from "@/services/apiService";

export default {
  name: "PropertyQuestions",
  data (){
    return {
      bedRoomCount: 0,
      halfBathCount: 0,
      fullBathCount: 0,
      floorCount: 0,
      hasBasement: false,
      yearBuilt: 0,
      lotSize: '',
      sqft: 0,
      garageSpaces: 0,
      carportSpaces: 0,
      hasFireplace: null,
      fireplaceType: undefined,
      pool: undefined,
      poolType: undefined
    }
  },
  methods: {
    onSelectedValue: function (field, saveAs, value) {
      this.setLocalValue(field, value)
      this.$emit('on-value-entry', { field: field, saveAs: saveAs, value: value });
      saveField(saveAs, value);
    },
    isSelected: function (field, value){
      return this[field] === value;
    },
    onBlurValue: function (field, saveAs) {
      const val = this.getLocalValue(field);
      this.onSelectedValue(field, saveAs, val)
    },
    setLocalValue(field, value) {
      switch (field) {
        case 'bedRoomCount':
          this.bedRoomCount = value;
          break;
        case 'fullBathCount':
          this.fullBathCount = value;
          break;
        case 'halfBathCount':
          this.halfBathCount = value;
          break;
        case 'floorCount':
          this.floorCount = value;
          break;
        case 'yearBuilt':
          this.yearBuilt = value;
          break;
        case 'sqft':
          this.sqft = value;
          break;
        case 'garageSpaces':
          this.garageSpaces = value;
          break;
        case 'carportSpaces':
        this.carportSpaces = value;
          break;
        case 'hasBasement':
        this.hasBasement = value;
          break;
        case 'lotSize':
        this.lotSize = value;
          break;
        case 'hasFireplace':
        this.hasFireplace = value;
          break;
        case 'fireplaceType':
        this.fireplaceType = value;
          break;
        case 'pool':
        this.pool = value;
          break;
        case 'poolType':
        this.poolType = value;
          break;
        default:
          return false;
      }
      return value;
    },
    getLocalValue(field) {
      switch (field) {
        case 'bedRoomCount':
          return this.bedRoomCount;
        case 'fullBathCount':
          return this.fullBathCount;
        case 'halfBathCount':
          return this.halfBathCount;
        case 'floorCount':
          return this.floorCount;
        case 'yearBuilt':
          return this.yearBuilt;
        case 'sqft':
          return this.sqft;
        case 'garageSpaces':
          return this.garageSpaces;
        case 'carportSpaces':
          return this.carportSpaces;        
        case 'lotSize':
          return this.lotSize;        
        default:
          return false;
      }
    }
  }
}
</script>
<style>

</style>